export default __webpack_public_path__ + "static/media/switchCam.63045f3a.svg";